import { render, staticRenderFns } from "./CompaniesDoc.vue?vue&type=template&id=4e50f41a"
import script from "./CompaniesDoc.vue?vue&type=script&lang=js"
export * from "./CompaniesDoc.vue?vue&type=script&lang=js"
import style0 from "./CompaniesDoc.vue?vue&type=style&index=0&id=4e50f41a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports